<template>
  <div
    class="event-student"
    :class="{ 'event-student--mobile': isMobile }"
  >
    <header class="es-head">
      <div class="es-head-row">
      <div class="es-title">
        <div class="es-tile">
          <v-icon
            size="22"
            color="primary"
          >
            mdi-account-multiple-plus-outline
          </v-icon>
        </div>
        <div>
          <div class="es-title-main">
            {{ $t($route.name, { name: $store.state.studentLabel }) }}
          </div>
          <div class="es-title-sub">
            {{ $t('academyEventStudentHint', { name: $store.state.studentLabel }) }}
          </div>
        </div>
      </div>
      <div class="es-head-tools">
        <button
          v-shortkey="['f5']"
          type="button"
          class="es-icon"
          :title="$t('refresh') + '(f5)'"
          @shortkey="getItems"
          @click="getItems"
        >
          <v-icon size="18">
            mdi-refresh
          </v-icon>
        </button>
        <log
          v-if="$store.state.permissions && $store.state.permissions.includes('logList')"
          ref="logRef"
          :type-prop="type"
          mode-prop="button"
        />
        <button
          type="button"
          class="es-icon es-icon--primary"
          :title="$t('newCustomer')"
          @click="goTo('customer')"
        >
          <v-icon size="18">
            mdi-account-plus-outline
          </v-icon>
        </button>
      </div>
      </div>
    </header>

    <div class="es-body">
      <div
        class="es-panes"
        :class="{ 'is-collapsed': ui.registeredCollapsed }"
      >
        <section class="es-pane es-pane--list">
          <div
            class="pl es-pl"
            :class="{ 'theme--dark': $vuetify.theme.isDark }"
          >
          <section class="es-card es-event">
          <div class="es-pickers">
            <div class="input-minimal es-picker">
              <autocomplete
                v-model="event"
                title="academyEventName"
                type="academyEvent"
                :value="event"
              />
            </div>
            <div
              v-if="event && event.type == 'interview'"
              class="input-minimal es-picker"
            >
              <autocomplete
                v-model="session"
                title="academySession"
                type="academySession"
                :value="session"
                :data="JSON.stringify({parent: event.id})"
              />
            </div>
          </div>
          <div
          v-if="event"
          class="es-facts"
        >
          <span class="es-fact">
            <v-icon size="16">mdi-calendar-start-outline</v-icon>
            {{ $t('startDate') }} <b>{{ event.start_date }}</b>
          </span>
          <span class="es-fact">
            <v-icon size="16">mdi-clock-outline</v-icon>
            {{ $t('startTime') }} <b class="es-ltr">{{ event.start_time }}</b>
          </span>
          <span class="es-fact">
            <v-icon size="16">mdi-counter</v-icon>
            {{ $t('sessionCount') }} <b>{{ event.session_count }}</b>
          </span>
          <span
            v-if="event.teacher"
            class="es-fact"
          >
            <v-icon size="16">mdi-account-tie-outline</v-icon>
            {{ $t('teacher') }} <b>{{ event.teacher.name }}</b>
          </span>
          <span
            v-if="event.place"
            class="es-fact"
          >
            <v-icon size="16">mdi-office-building-outline</v-icon>
            {{ $t('place') }} {{ $t('class') }} <b>{{ event.place.name }}</b>
          </span>
          <span
            v-if="event.arrayDays && event.arrayDays.length > 0"
            class="es-fact es-fact--days"
          >
            <v-icon size="16">mdi-calendar-week-outline</v-icon>
            {{ $t('daysHolding') }}
            <span
              v-for="(day, index) in event.arrayDays"
              :key="index"
              class="es-day"
            >{{ $t(day) }}</span>
          </span>
        </div>
          </section>
          <header class="pl-head">
            <div class="pl-head__title-block">
              <span class="pl-head__icon"><v-icon size="18">mdi-account-search-outline</v-icon></span>
              <div>
                <h1 class="pl-head__title">
                  {{ $t('academyEventStudentCandidates', { name: $store.state.studentLabel }) }}
                </h1>
                <div class="pl-head__sub">
                  <span class="pl-num">{{ faNum($numberFormat(totalItems)) }}</span> {{ $t('plRecords') }}
                </div>
              </div>
            </div>
            <label class="pl-search">
              <v-icon size="18">mdi-magnify</v-icon>
              <input
                v-model="search"
                type="search"
                class="pl-search__input"
                :placeholder="$t('search')"
                autocomplete="off"
              >
              <button
                v-if="search"
                type="button"
                class="pl-search__clear"
                :aria-label="$t('clear')"
                @click="search = null"
              >
                <v-icon size="16">mdi-close</v-icon>
              </button>
            </label>
            <span class="pl-head__spacer" />
          </header>
          <div class="pl-table es-table">
            <v-data-table
              v-if="headers"
              ref="datatable"
              v-column-resize="eventStudentColumnPlugins"
              v-column-drag="eventStudentColumnPlugins"
              v-column-pin="eventStudentColumnPlugins"
              v-model="selected"
              height="100%"
              fixed-header
              :headers="showHeaders"
              :items="items"
              :options.sync="options"
              :server-items-length="totalItems"
              :loading="loading"
              :show-select="showSelect"
              multi-sort
              item-key="id"
              :footer-props="{
                showFirstLastPage: true,
                itemsPerPageOptions: [10, 25, 50, 100, 500],
                firstIcon: 'mdi-chevron-double-left',
                lastIcon: 'mdi-chevron-double-right',
                prevIcon: 'mdi-chevron-left',
                nextIcon: 'mdi-chevron-right'
              }"
            >
              <template v-slot:item.actions="{ item }">
                <div class="pl-action-cell">
                <v-menu offset-y>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      color="primary"
                      v-bind="attrs"
                      class="pl-action-cell__btn"
                      icon
                      x-small
                      v-on="on"
                    >
                      <v-icon medium>
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      link
                      @click="edit(item)"
                    >
                      <v-list-item-icon>
                        <v-icon class="mt-2">
                          mdi-clipboard-edit
                        </v-icon>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              icon
                              small
                              v-on="on"
                              @click.stop.prevent="newTab('customerEdit', item)"
                            >
                              <v-icon
                                small
                                color="primary"
                              >
                                mdi-content-duplicate
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('newTab') }}</span>
                        </v-tooltip>
                      </v-list-item-icon>
                      <v-list-item-title v-text="$t('edit')" />
                    </v-list-item>
                    <v-list-item
                      link
                      @click="turnover(item)"
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-recycle-variant</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title v-text="$t('turnover')" />
                    </v-list-item>
                    <v-list-item
                      v-clipboard:copy="$baseURL + '/customer/edit/' + item.id"
                      link
                    >
                      <v-list-item-icon>
                        <v-icon>mdi-link</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title v-text="$t('copy-link')" />
                    </v-list-item>
                    <v-list-item
                      link
                      @click="openDeleteDialog(item)"
                    >
                      <v-list-item-icon>
                        <v-icon color="pink">
                          mdi-trash-can-outline
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-title v-text="$t('remove')" />
                    </v-list-item>
                  </v-list>
                </v-menu>
                <span class="pl-action-cell__row"><a @click="edit(item)">{{ faNum(parseInt(items.indexOf(item)) + parseInt(from)) }}</a></span>
                </div>
              </template>
              <template v-slot:item.firstname="{ item }">
                <a
                  class="pl-key"
                  @click="edit(item)"
                >
                  {{ item.firstname }} {{ (item.lastname ? item.lastname : '') }} {{ (item.code ? '(' + item.code + ')' : '') }}
                </a>
              </template>
              <template v-slot:item.row="{ item }">
                {{ parseInt(items.indexOf(item))+ parseInt(from) }}
              </template>
              <template v-slot:item.id="{ item }">
                <a
                  class="pl-key"
                  @click="edit(item)"
                >
                  {{ item.id }}
                </a>
              </template>
              <template v-slot:item.tags="{ item }">
                <div
                  class="es-tags"
                  @click="edit(item)"
                >
                  <span
                    v-for="(tag, index) in item.tags"
                    :key="index"
                    class="es-tag"
                    :style="{ background: tag.color }"
                  >{{ tag.text }}</span>
                </div>
              </template>
              <template v-slot:item.action="{ item }">
                <button
                  v-if="event"
                  type="button"
                  class="es-add"
                  @click="openAddToEventDialog(item)"
                >
                  <v-icon size="16">
                    mdi-plus
                  </v-icon>
                  {{ $t('addToEvent') }}
                </button>
              </template>
              <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t('of') }} {{ faNum($numberFormat(itemsLength)) }}
              </template>
              <template v-slot:footer.prepend>
                <div class="pl-goto">
                  <span>{{ $t('goToPage') }}</span>
                  <input
                    :value="options.page || 1"
                    type="number"
                    min="1"
                    :max="pageCountOf()"
                    class="pl-goto__input pl-num"
                    @change="goPage($event.target.value)"
                  >
                  <span class="pl-num">/ {{ faNum(pageCountOf()) }}</span>
                </div>
              </template>
            </v-data-table>
          </div>
          </div>
        </section>

        <button
          v-if="ui.registeredCollapsed"
          type="button"
          class="es-card es-rail"
          :title="$t('academyEventStudentExpand')"
          @click="toggleRegistered"
        >
          <v-icon size="18">
            mdi-chevron-double-right
          </v-icon>
          <span class="es-card-tile es-card-tile--green">
            <v-icon size="20">
              mdi-account-check-outline
            </v-icon>
          </span>
          <span class="es-count es-count--green">{{ students.length }}</span>
          <span class="es-rail-text">{{ $t('registeredStudents', {name: $store.state.studentLabel}) }}</span>
        </button>
        <section
          v-else
          class="es-card es-pane"
        >
          <div class="es-pane-head">
            <div class="es-card-tile es-card-tile--green">
              <v-icon size="20">
                mdi-account-check-outline
              </v-icon>
            </div>
            <div class="es-pane-title">
              {{ $t('registeredStudents', {name: $store.state.studentLabel}) }}
              <span class="es-count es-count--green">{{ students.length }}</span>
            </div>
            <button
              type="button"
              class="es-icon es-icon--sm"
              :title="$t('academyEventStudentCollapse')"
              @click="toggleRegistered"
            >
              <v-icon size="18">
                mdi-chevron-double-left
              </v-icon>
            </button>
          </div>
          <div class="es-students">
            <div
              v-for="(student, i) in students"
              :key="i"
              class="es-student"
            >
              <span class="es-student-num">{{ +i + +1 }}</span>
              <span class="es-student-name">{{ student.name }}</span>
              <button
                type="button"
                class="es-icon es-icon--sm es-icon--primary"
                :title="$t('sendRegisterSms')"
                @click="sendSmsStudentEvent(student)"
              >
                <v-icon size="18">
                  mdi-message-reply-text-outline
                </v-icon>
              </button>
              <button
                type="button"
                class="es-icon es-icon--sm es-icon--danger"
                :title="$t('remove')"
                @click="removeStudent(student)"
              >
                <v-icon size="18">
                  mdi-delete-outline
                </v-icon>
              </button>
            </div>
            <div
              v-if="!students || students.length === 0"
              class="es-empty"
            >
              <v-icon size="32">
                mdi-account-off-outline
              </v-icon>
              <span>{{ event ? $t('no-data') : $t('academyEventStudentPick') }}</span>
            </div>
          </div>
        </section>
      </div>
    </div>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="deletDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="400"
    >
      <v-card class="es-dialog">
        <div class="es-dialog-body">
          <div class="es-dialog-tile es-dialog-tile--danger">
            <v-icon size="26">
              mdi-trash-can-outline
            </v-icon>
          </div>
          <p>{{ $t('are-you-sure-delete-this-case') }}</p>
        </div>
        <div class="es-dialog-foot">
          <v-btn
            v-if="selected.length > 0"
            color="pink"
            depressed
            dark
            class="app-form-action-btn"
            @click="removegroup"
          >
            {{ $t('remove') }}
          </v-btn>
          <v-btn
            v-if="selected.length == 0"
            color="pink"
            depressed
            dark
            class="app-form-action-btn"
            @click="remove"
          >
            {{ $t('remove') }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="grey"
            outlined
            class="app-form-action-btn"
            @click="deletDialog = false"
          >
            {{ $t('cancel') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="addToEventDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="440"
    >
      <v-card class="es-dialog">
        <div class="es-dialog-body">
          <div class="es-dialog-tile">
            <v-icon size="26">
              mdi-account-plus-outline
            </v-icon>
          </div>
          <p>{{ $t('doYouSureToAddStudent', {name: $store.state.studentLabel}) }}</p>
          <div
            v-if="event"
            class="es-dialog-sub"
          >
            {{ event.name }}
          </div>
        </div>
        <div class="es-dialog-foot">
          <v-btn
            color="primary"
            depressed
            class="app-form-action-btn"
            @click="addToEvent('active')"
          >
            <v-icon
              left
              size="18"
            >
              mdi-message-processing-outline
            </v-icon>
            {{ $t('addStudentWithSms', {name: $store.state.studentLabel}) }}
          </v-btn>
          <v-btn
            color="primary"
            outlined
            class="app-form-action-btn ms-2"
            @click="addToEvent('deactive')"
          >
            {{ $t('addStudent', {name: $store.state.studentLabel}) }}
          </v-btn>
          <v-spacer />
          <v-btn
            color="grey"
            text
            class="app-form-action-btn"
            @click="addToEventDialog = false"
          >
            {{ $t('cancel') }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="960"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("academyEventStudentFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">

          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-account-group-outline</v-icon>
              {{ $t("academyFilterBasics") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <div class="acf-switch">
                <span class="acf-switch__label">{{ $t("lead") }}</span>
                <v-switch
                  v-model="lead"
                  class="acf-switch__control mt-0 pt-0"
                  value="active"
                  color="primary"
                  dense
                  inset
                  hide-details
                  :ripple="false"
                />
              </div>
              <div class="acf-switch">
                <span class="acf-switch__label">{{ $t("active") }}</span>
                <v-switch
                  v-model="status"
                  class="acf-switch__control mt-0 pt-0"
                  value="active"
                  color="primary"
                  dense
                  inset
                  hide-details
                  :ripple="false"
                />
              </div>
              <v-select
                v-model="financialStatus"
                :label="$t('financial-status')"
                :items="financialStatusItems"
                dense
                outlined
                clearable
                hide-details
                item-value="value"
                item-text="text"
              />
              <autocomplete
                v-model="category"
                :title="$t('category')"
                type="accountCategory"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="attractionMethod"
                :title="$t('attractionMethod')"
                type="attractionMethod"
                :multiple="true"
                :filter="true"
              />
              <autocomplete
                v-model="registerar"
                :title="$t('registerar')"
                type="partners"
                :multiple="true"
                :filter="true"
              />
              <tag v-model="tag" />

              <v-select
                v-model="selectedHeaders"
                :items="headers"
                :label="$t('sellFilterColumns')"
                dense
                outlined
                multiple
                return-object
                hide-details
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum(selectedHeaders.length - 1) }}
                  </span>
                </template>
              </v-select>

            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="getItems">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            ref="refTask"
            task-type="account"
            :ref-item="taskItem"
            ref-type="account"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialogList"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialogList = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('tasks') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task-list
            ref="refTaskList"
            type="account"
            :ref-id="refId"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
    <!--    upload dialog-->
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="uploadDialog"
      width="500"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="uploadDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col
          class="mt-0 pt-0 pr-7"
        >
          <upload
            type-prop="customer"
            :get-item="uploadDialog"
            @close="uploadDialog=false"
          />
        </v-col>
        <v-card-actions>
          <v-row class="ma-0" />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import Task from '../task/task'
  import TaskList from '../task/list'
  import Upload from '../../components/general/upload/upload'
  import General from '../../../../Mixins/general'
  import Print from '../../components/general/Print/Index'
  import Vue from 'vue'
  import { applyColumnSettings, loadColumnSettings } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  // import pdfPrint from '../../components/general/Print/pdfPrintTable'
  export default {
    name: 'StudentList',
    components: {
      Tag: () => import('../../components/general/Tag/tag'),
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      Print,
      Task,
      // pdfPrint,
      TaskList,
      Upload,
    },
    mixins: [General],
    props: ['eventProp', 'sessionProp'],
    data: () => ({
      selected: [],
      eventStudentReq: true,
      session: null,
      event: null,
      excelItems: null,
      category: null,
      integratorType: null,
      rangeDate: null,
      registerar: null,
      attractionMethod: null,
      customerStatusItems: null,
      financialStatusItems: null,
      addToEventDialog: false,
      student: null,
      printDialog: false,
      uploadDialog: false,
      accountDialog: false,
      deletDialog: false,
      filter: false,
      financialStatus: null,
      customerStatus: null,
      status: 'active',
      taskindex: 0,
      lead: null,
      refId: null,
      taskItem: null,
      model: null,
      from: 1,
      taskDialog: null,
      taskDialogList: null,
      showSelect: null,
      tag: null,
      temp: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbarColor: null,
      snakbar: false,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      deleteItem: null,
      students: [],
      headers: null,
      personnel: null,
      id: null,
      search: null,
      renderTable: null,
      selectedHeaders: [],
    }),
    created () {
      // UI-only state kept out of data()
      // collapsed by default; only an explicit "open" choice is remembered
      var collapsed = true
      try {
        collapsed = localStorage.getItem('academyEventStudentRegisteredCollapsed') !== '0'
      } catch (e) {}
      this.ui = Vue.observable({ registeredCollapsed: collapsed })
    },
    computed: {

      proListRootStyle () {
        var theme = this.$vuetify.theme
        var t = theme.themes[theme.isDark ? 'dark' : 'light'] || {}
        var primary = typeof t.primary === 'string' ? t.primary : (t.primary && t.primary.base) || '#1976d2'
        return { '--pl-primary': primary, '--pl-primary-soft': primary + '1a' }
      },

      activeFilterChips () {
        var app = this

      var has = function (v) {
        if (Array.isArray(v)) return v.length > 0
        return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
      }
      var show = function (v) {
        if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
        if (v && typeof v === 'object') return v.name || v.text || v.label || ''
        return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
      }

        var defs = [
          ['lead', app.$t('lead'), app.lead === 'active' ? app.$t('lead') : ''],
          ['status', app.$t('active'), app.status === 'active' ? app.$t('active') : ''],
          ['financialStatus', app.$t('financial-status')],
          ['category', app.$t('category')],
          ['attractionMethod', app.$t('attractionMethod')],
          ['registerar', app.$t('registerar')],
          ['tag', app.$t('tag')],
        ]
        return defs
          .filter(function (d) {
            if (d[0] === 'lead' || d[0] === 'status') return app[d[0]] === 'active'
            return has(app[d[0]])
          })
          .map(function (d) {
            return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) }
          })
      },
      // column resize / drag / pin like the other lists (persisted via panel-ui)
      eventStudentColumnPlugins () {
        return {
          headers: this.headers,
          visibleHeaders: this.headers ? this.showHeaders : [],
          locked: ['actions', 'firstname'],
          anchor: 'firstname',
          minWidth: 60,
          persistKey: 'academy-event-student-columns',
        }
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          if (app.type !== 'sell') {
            if (s.value === 'pre_invoice') {
            } else {
              return app.selectedHeaders.includes(s)
            }
          } else {
            return app.selectedHeaders.includes(s)
          }
        })
      },
    },
    watch: {
      taskDialogList (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      taskDialog (val, old) {
        if (!val) {
          this.getItems()
        }
      },
      data (val, oldVal) {
        this.model = val.description
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          app.page = app.options.page
          app.itemsPerPage = app.options.itemsPerPage
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      event (val) {
        if (val) {
          this.getStudents()
        } else {
          this.students = []
        }
      },
      session (val) {
        if (val) {
          this.getStudents()
        } else {
          this.students = []
        }
      },
    },
    activated () {
      this.getItems()
    },
    beforeMount () {
      this.customerStatusItems = [
        {
          value: 'lead',
          text: this.$t('lead'),
        },
        {
          value: 'on',
          text: this.$t('active'),
        },
      ]
      this.financialStatusItems = [
        {
          value: '>',
          text: this.$t('debtor'),
        },
        {
          value: '<',
          text: this.$t('creditor'),
        },
        {
          value: '=',
          text: this.$t('clearing'),
        },
      ]
      this.headers = [
        {
          text: this.$t('#'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 42,
          class: 'pl-action-col',
          cellClass: 'pl-action-col',
        },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'id',
          table: 'users.id',
        },
        {
          text: this.$t('name'),
          sortable: true,
          value: 'firstname',
          table: 'users.name',
          width: 240,
        },
        {
          text: this.$t('national-code'),
          sortable: true,
          value: 'national_code',
          table: 'users.national_code',
        },
        {
          text: this.$t('tag'),
          sortable: false,
        },
        {
          text: this.$t('actions'),
          sortable: false,
          value: 'action',
        },
      ]
      if (this.eventProp) {
        this.event = this.eventProp
      }
      if (this.sessionProp) {
        this.session = this.sessionProp
      }
    },
    mounted () {
      this.headersMap = this.headers
      this.selectedHeaders = this.headers
      this.loadEventStudentColumns()
      if (this.input) {
        this.model = this.input
      }
      // this.getItems()
    },
    methods: {

      resetFilters () {
        var app = this
        ;['lead', 'status', 'financialStatus', 'category', 'attractionMethod', 'registerar', 'tag'].forEach(function (k) { app[k] = null })
      },
      loadEventStudentColumns () {
        var app = this
        if (!app.headers || !app.headers.length) return
        var opts = { locked: ['actions', 'firstname'], anchor: 'firstname' }
        reorderPinnedHeaders(app.headers, opts)
        loadColumnSettings(app, 'academy-event-student-columns').then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, opts)
          app.$forceUpdate()
        })
      },
      faNum (v) {
        if (v === null || v === undefined) return v
        var str = String(v)
        if (!(this.$i18n && String(this.$i18n.locale).indexOf('fa') === 0)) return str
        return str.replace(/[0-9]/g, function (d) { return '۰۱۲۳۴۵۶۷۸۹'[d] })
      },
      pageCountOf () {
        var per = this.options && this.options.itemsPerPage
        if (!per || per < 0) return 1
        return Math.max(1, Math.ceil((this.totalItems || 0) / per))
      },
      // same as using the pager: options.sync -> existing watcher -> getItems
      goPage (n) {
        var page = Math.min(this.pageCountOf(), Math.max(1, parseInt(n) || 1))
        this.options = Object.assign({}, this.options, { page: page })
      },
      toggleRegistered () {
        this.ui.registeredCollapsed = !this.ui.registeredCollapsed
        try {
          localStorage.setItem('academyEventStudentRegisteredCollapsed', this.ui.registeredCollapsed ? '1' : '0')
        } catch (e) {}
      },
      openAddToEventDialog (item) {
        this.student = item
        this.addToEventDialog = true
      },
      removeStudent (item) {
        const i = this.students.indexOf(item)
        if (i > -1) {
          this.students.splice(i, 1)
        }
        var data = {
          event: this.event,
          session: this.session,
          student: item,
        }
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'academyStudents/' + item.registerId, { data: data })
          .then(res => {
            res = res.data
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      submit (student, sms) {
        if (!this.event) {
          return false
        }
        var app = this
        app.addToEventDialog = false
        app.loading = true
        app.clearing = true
        app.showing = true
        var data = {
          event: this.event,
          session: this.session,
          student: student,
          sms: sms,
        }
        app.$axios.post(this.$endpoint + 'academyStudents', data)
          .then(res => {
            res = res.data
            student.registerId = res.data.id
            app.student = null
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      sendSmsStudentEvent (student) {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'academyStudents', {
          params: {
            sendSmsStudentEvent: 'active',
            event: app.event,
            student: student,
          },
        })
          .then(res => {
            res = res.data
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      getStudents () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'academyStudents', {
          params: {
            getEventStudents: 'active',
            eventId: app.event.id,
            sessionId: (app.session ? app.session.id : null),
          },
        })
          .then(res => {
            res = res.data
            app.students = res
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      addToEvent (sms) {
        var student = {
          id: this.student.id,
          name: this.student.name,
          registerId: null,
        }
        const i = this.students.findIndex(h => h.id === this.student.id)
        if (i > -1) {
          this.snakbarColor = 'pink'
          this.snakbarText = this.$t('iterationStudent', { name: this.$store.state.studentLabel })
          this.snakbar = true
          return false
        }
        this.students.push(student)
        this.submit(student, sms)
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        this.$router.push({ name: 'customerEdit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'customer/show', {
          params: {
            search: app.search,
            registerar: app.registerar,
            rangeDate: app.rangeDate,
            category: app.category,
            attractionMethod: app.attractionMethod,
            status: app.status,
            personnel: app.personnel,
            lead: app.lead,
            page: app.page,
            type: app.type,
            sortBy: app.sortBy,
            integratorType: app.integratorType,
            options: app.options,
            tag: app.tag,
            customerStatus: app.customerStatus,
            remainStatus: app.financialStatus,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.last_page = res.last_page
            app.from = res.from
            // const table = this.$refs.datatable.$el.querySelector('table')
            // const [header] = table.tHead.rows
            // const props = [...header.cells].map(h => h.textContent)
            // const rows = [...table.rows].map(r => {
            //   const entries = [...r.cells].map((c, i) => {
            //     return [props[i], c.textContent]
            //   })
            //   return Object.fromEntries(entries)
            // })
            // app.renderTable = this.$refs.datatable.$el.querySelector('thead')
          })
          .catch(err => {
            var error = err.response
            if (error.status === 401) {
              this.$router.push({ name: 'logout' })
            }
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true

        app.$axios.delete(this.$endpoint + 'customer/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'customer/0', {
          params: { deleteItems: app.selected },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      print () {
        this.$htmlToPaper('print')
      },
      turnover (item) {
        this.$router.push({ name: 'turnover', params: { accountProp: { fin_id: item.fin_id, name: item.name } } })
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";
.event-student {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 98px);
  background: #f3f7fc;
  border: 1px solid rgba(15, 23, 42, .08);
  border-radius: 6px;
  overflow: hidden;
  ::v-deep .v-input { height: auto !important; margin: 0; padding: 0; }
}
.es-head {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 16px;
  background: #fff;
  border-bottom: 1px solid rgba(15, 23, 42, .07);
}
.es-title { display: flex; align-items: center; gap: 12px; min-width: 0; }
.es-tile, .es-card-tile {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(25, 118, 210, .1);
}
.es-tile { width: 40px; height: 40px; }
.es-card-tile {
  width: 32px;
  height: 32px;
  .v-icon { color: var(--v-primary-base, #1976d2); }
  &--green { background: rgba(46, 125, 50, .1); .v-icon { color: #2e7d32; } }
}
.es-title-main { font-weight: 600; font-size: .95rem; }
.es-title-sub { font-size: .78rem; opacity: .6; }
.es-head-tools { display: flex; align-items: center; gap: 6px; }
.es-icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(15, 23, 42, .04);
  color: rgba(15, 23, 42, .7);
  .v-icon { color: inherit; }
  &:hover { background: rgba(25, 118, 210, .1); color: var(--v-primary-base, #1976d2); }
  &--sm { width: 30px; height: 30px; }
  &--primary { color: var(--v-primary-base, #1976d2); }
  &--danger:hover { background: rgba(194, 24, 91, .1); color: #c2185b; }
}
.es-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
}
.es-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, .08);
  border-radius: 6px;
}
.es-pickers { display: flex; gap: 10px; flex-wrap: wrap; }
.es-picker { width: 280px; }
.es-facts { display: flex; flex-wrap: wrap; gap: 6px; flex: 1; min-width: 0; }
.es-fact {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 30px;
  padding: 0 10px;
  border-radius: 6px;
  background: rgba(25, 118, 210, .06);
  font-size: .78rem;
  white-space: nowrap;
  .v-icon { color: var(--v-primary-base, #1976d2); }
  b { font-weight: 600; }
}
.es-day {
  padding: 1px 6px;
  border-radius: 6px;
  background: #fff;
  color: var(--v-primary-base, #1976d2);
  font-size: .72rem;
  font-weight: 600;
}
.es-event-empty { display: flex; align-items: center; gap: 6px; font-size: .8rem; opacity: .6; }
.es-ltr { direction: ltr; unicode-bidi: isolate; }
.es-panes {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 12px;
}
.es-pane {
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.es-pane-head {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 56px;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(15, 23, 42, .07);
}
.es-pane-title {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: .85rem;
}
.es-count {
  min-width: 24px;
  height: 20px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(25, 118, 210, .1);
  color: var(--v-primary-base, #1976d2);
  font-size: .72rem;
  &--green { background: rgba(46, 125, 50, .1); color: #2e7d32; }
}
.es-search { width: 220px; }
.es-table {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  ::v-deep .v-data-table {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: transparent;
  }
  ::v-deep .v-data-table__wrapper { flex: 1 1 auto; min-height: 0; overflow-x: hidden; }
  ::v-deep .v-data-table-header th { background: #f8fafd !important; font-size: .75rem; }
  ::v-deep .v-data-footer { flex-shrink: 0; border-top: 1px solid rgba(15, 23, 42, .07); }
}
.es-link { color: var(--v-primary-base, #1976d2); }
.es-tags { display: flex; flex-wrap: wrap; gap: 3px; padding: 3px 0; }
.es-tag { padding: 1px 6px; border-radius: 6px; color: #fff; font-size: .7rem; }
.es-add {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  background: rgba(25, 118, 210, .1);
  color: var(--v-primary-base, #1976d2);
  font-size: .75rem;
  font-weight: 600;
  white-space: nowrap;
  .v-icon { color: inherit; }
  &:hover { background: rgba(25, 118, 210, .18); }
}
.es-students {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  > * { flex-shrink: 0; }
}
.es-student {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 8px;
  border: 1px solid rgba(15, 23, 42, .07);
  border-radius: 6px;
  &:hover { border-color: rgba(25, 118, 210, .25); background: rgba(25, 118, 210, .03); }
}
.es-student-num {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(46, 125, 50, .1);
  color: #2e7d32;
  font-size: .72rem;
  font-weight: 700;
}
.es-student-name { flex: 1; min-width: 0; font-size: .82rem; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.es-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 32px 16px;
  opacity: .5;
  font-size: .8rem;
  text-align: center;
}
.es-dialog { border-radius: 6px !important; overflow: hidden; }
.es-dialog-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 24px 20px 16px;
  text-align: center;
  p { margin: 0; font-weight: 500; }
}
.es-dialog-sub { font-size: .8rem; opacity: .6; }
.es-dialog-tile {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: rgba(25, 118, 210, .1);
  .v-icon { color: var(--v-primary-base, #1976d2); }
  &--danger { background: rgba(194, 24, 91, .1); .v-icon { color: #c2185b; } }
}
.es-dialog-foot {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 12px 16px;
  border-top: 1px solid rgba(15, 23, 42, .07);
}

.event-student--mobile {
  height: auto;
  border: 0;
  border-radius: 0;
  overflow: visible;
  .es-head { padding: 12px; }
  .es-body { padding: 8px; }
  .es-picker, .es-search { width: 100%; }
  .es-pane-head { flex-wrap: wrap; }
  .es-panes { grid-template-columns: 1fr; }
  .es-table { min-height: 420px; }
  .es-students { max-height: 360px; }
}

.theme--dark {
  .event-student { background: #121212; border-color: rgba(255, 255, 255, .08); }
  .es-head, .es-card { background: #1e1e1e; border-color: rgba(255, 255, 255, .08); }
  .es-pane-head, .es-dialog-foot { border-color: rgba(255, 255, 255, .08); }
  .es-tile, .es-card-tile, .es-dialog-tile { background: rgba(100, 181, 246, .14); }
  .es-icon { background: rgba(255, 255, 255, .06); color: rgba(255, 255, 255, .8); }
  .es-fact { background: rgba(100, 181, 246, .1); }
  .es-fact .v-icon, .es-card-tile .v-icon, .es-link, .es-icon--primary, .es-count, .es-add { color: #90caf9; }
  .es-day { background: #2a2a2a; color: #90caf9; }
  .es-student { border-color: rgba(255, 255, 255, .08); }
  .es-table ::v-deep .v-data-table-header th { background: #242424 !important; }
  .es-table ::v-deep .v-data-footer { border-color: rgba(255, 255, 255, .08); }
}
.es-head-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 40px;
}
.es-event {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 14px;
  padding: 10px 12px;
}
.es-panes.is-collapsed { grid-template-columns: 1fr 56px; }
.es-rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  cursor: pointer;
  .v-icon { color: rgba(15, 23, 42, .6); }
  &:hover { border-color: rgba(25, 118, 210, .35); }
}
.es-rail-text {
  writing-mode: vertical-rl;
  font-size: .78rem;
  font-weight: 600;
  opacity: .75;
  white-space: nowrap;
}
.es-pl {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  .pl-table { flex: 1 1 auto; min-height: 0; display: flex; flex-direction: column; }
}
.es-pane--list { background: transparent; border: 0; }
.event-student--mobile {
  .es-head-row { flex-wrap: wrap; }
  .es-panes.is-collapsed { grid-template-columns: 1fr; }
  .es-rail { flex-direction: row; padding: 8px 12px; }
  .es-rail-text { writing-mode: horizontal-tb; }
}
.theme--dark .es-rail .v-icon { color: rgba(255, 255, 255, .7); }
</style>
